import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Flex,
  Heading,
  Input,
  Link,
  Stack,
  Text,
  Image,
  Select,
  Checkbox,

} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/images/drhvac.svg";
import { createUser } from "../utils/api";

const SignupForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    password: "",
    confirmPassword: "",
    role: "user",
  });
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      setMessage("Passwords do not match.");
      return;
    }

    try {
      const response = await createUser({
        full_name: formData.full_name,
        email: formData.email,
        password: formData.password,
        role: formData.role,
      });

      const data = await response.json();
      if (!response.ok) {
        setMessage(data.error || "Signup failed.");
      } else {
        setMessage(
          formData.role === "admin"
            ? "Signup successful! Awaiting admin approval."
            : "Signup successful! Awaiting approval.",
        );
        setTimeout(() => navigate("/"), 3000);
      }
    } catch (error) {
      console.error("Signup failed:", error);
      setMessage("Signup failed. Please try again.");
    }
  };

  return (
    <Flex
      height="100vh"
      justifyContent="center"
      alignItems="center"
      bg="gray.50"
      px={4}
    >
      <Box
        w={500}
        as="form"
        onSubmit={handleSubmit}
        bg="white"
        p={8}
        rounded="lg"
        boxShadow="0px 10px 20px rgba(0, 0, 0, 0.1), 0px 6px 6px rgba(0, 0, 0, 0.1)"
        w={{ base: "90%", sm: "400px" }}
      >
        <Flex justify="space-between" align="center" mb={35}>
          {/* Left: Image */}
          <Image w={100} src={Logo} />

          {/* Right: Login Heading */}
          <Heading color="#1c4b7e" size="md">
            Signup
          </Heading>
        </Flex>
        <Stack spacing={4}>
          <Input
            className="form-input"
            borderRadius={0}
            variant="unstyled"
            borderBottom="2px solid #1c4b7e"
            background="white"
            _focus={{
              background: "white",
              outline: "none",
              borderBottom: "2px solid #1c4b7e",
              boxShadow: "none",
            }}
            _hover={{
              borderBottom: "2px solid #1c4b7e",
              background: "white",
            }}
            placeholder="Full Name"
            value={formData.full_name}
            onChange={(e) =>
              setFormData({ ...formData, full_name: e.target.value })
            }
            required
          />
          <Input
            className="form-input"
            borderRadius={0}
            variant="unstyled"
            borderBottom="2px solid #1c4b7e"
            _focus={{
              outline: "none",
              borderBottom: "2px solid #1c4b7e",
              boxShadow: "none",
            }}
            _hover={{
              borderBottom: "2px solid #1c4b7e",
            }}
            type="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={(e) =>
              setFormData({ ...formData, email: e.target.value })
            }
            required
          />
   <Box display="flex" flexDirection="row" gap={2}>
    <Text>User Type</Text>
  <Checkbox
    isChecked={formData.role === "user"}
    onChange={() => setFormData({ ...formData, role: "user" })}
  >
    User
  </Checkbox>

  <Checkbox
    isChecked={formData.role === "admin"}
    onChange={() => setFormData({ ...formData, role: "admin" })}
  >
    Admin
  </Checkbox>
</Box>
          <Input
            className="form-input"
            borderRadius={0}
            variant="unstyled"
            borderBottom="2px solid #1c4b7e"
            background="white"
            _focus={{
              background: "white",
              outline: "none",
              borderBottom: "2px solid #1c4b7e",
              boxShadow: "none",
            }}
            _hover={{
              borderBottom: "2px solid #1c4b7e",
              background: "white",
            }}
            type="password"
            placeholder="Password"
            value={formData.password}
            onChange={(e) =>
              setFormData({ ...formData, password: e.target.value })
            }
            required
          />
          <Input
            className="form-input"
            borderRadius={0}
            variant="unstyled"
            borderBottom="2px solid #1c4b7e"
            _focus={{
              outline: "none",
              borderBottom: "2px solid #1c4b7e",
              boxShadow: "none",
            }}
            _hover={{
              borderBottom: "2px solid #1c4b7e",
            }}
            type="password"
            placeholder="Confirm Password"
            value={formData.confirmPassword}
            onChange={(e) =>
              setFormData({ ...formData, confirmPassword: e.target.value })
            }
            required
          />
          <Button
            type="submit" // Ensure this button submits the form
            colorScheme="blue"
            size="lg"
            w="full"
            bg="#00aeef"
            color="white"
            _hover={{ bg: "#1c4b7e" }}
            _focus={{
              boxShadow: "0 0 0 3px rgba(0, 174, 239, 0.5)",
            }}
            _active={{
              bg: "#1c4b7e",
              transform: "scale(0.98)",
            }}
            mt={35}
          >
            Sign Up
          </Button>
        </Stack>
        {message && (
          <Text
            mt={4}
            color={message.includes("successful") ? "green.500" : "red.500"}
          >
            {message}
          </Text>
        )}
        <Text mt={6} fontSize="sm" textAlign="center" color="gray.500">
          Already have an account?{" "}
          <Link href="/" color="#00aeef">
            Login
          </Link>
        </Text>
      </Box>
    </Flex>
  );
};

export default SignupForm;
